module.exports = __webpack_public_path__ + "static/magaseek-ac235bfe636926413837192cf1114c02.svg";